import { createFileRoute } from "@tanstack/react-router"
import BudgetBreakdownView from "~/components/budget/BudgetBreakdownView"
import NotFound from "~/components/reusable/NotFound"
import { useFlags } from "~/features/feature-flags"

export const Route = createFileRoute("/_auth/budgets/_layout/$fiscalYear/_layout/breakdown")({
  component: RouteComponent,
})

function RouteComponent() {
  const { fiscalYear } = Route.useParams()
  const { budgetUnreleased } = useFlags()
  if (!budgetUnreleased) return <NotFound />
  return <BudgetBreakdownView year={fiscalYear} />
}
